export default "__VITE_ASSET__BhRZiIbG__"